export enum EnumReferralStatus {
    Created = '00000510-1000-0000-0000-000000000001',
    Pending = '00000510-1000-0000-0000-000000000002',
    Appointment = '00000510-1000-0000-0000-000000000003',
    Canceled = '00000510-1000-0000-0000-000000000004'
}
